import axios, {
  AxiosInstance,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from "axios";
import { store } from "../redux/Store";

// Function to create an Axios instance with a dynamic port
const api = (port: string): AxiosInstance => {
  const apiInstance = axios.create({
    baseURL: port, // Append the port to the fixed base URL
    headers: { "Content-Type": "application/json" },
  });

  // Add request interceptor
  apiInstance.interceptors.request.use(
    (config: InternalAxiosRequestConfig) => {
      const state = store.getState(); // Get the Redux state
      const token = state.auth?.token; // Retrieve the token from the state
      // const token =
      //   "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6IjYiLCJyb2xlIjoiIiwibmJmIjoxNzM3Njk4MjE3LCJleHAiOjE3MzgzMDMwMTcsImlhdCI6MTczNzY5ODIxN30.MTjt7BGgvE89haQeBTApIMWopDUHm5ZX9kImMZm-OEA";

      if (token) {
        // Safely set the Authorization header if the token exists
        config.headers = {
          ...config.headers, // Ensure compatibility with AxiosRequestHeaders
          Authorization: `Bearer ${token}`,
        } as InternalAxiosRequestConfig["headers"];
      }
      return config; // Return the modified config
    },
    (error) => Promise.reject(error) // Reject promise in case of an error
  );

  // Add response interceptor
  apiInstance.interceptors.response.use(
    (response: AxiosResponse) => response, // Return the response for successful requests
    (error) => {
      if (error?.response) {
        // If the response contains errors, reject with the error details
        return Promise.reject(error?.response?.data?.errors);
      }

      // For other errors, reject with a generic error object
      return Promise.reject({
        message: error,
      });
    }
  );

  return apiInstance;
};

export default api;
